import React from 'react'
import styled from 'styled-components'
import { PostTags } from './PostTags'

const Wrapper = styled.header`
  margin-bottom: var(--spacing-8);
`

const Header = styled.h1`
  margin: 0 0 var(--spacing-2) 0;
  font-weight: 800;
`

export const PostViewHeader = ({ title, tags, subheader }) => {
  return (
    <Wrapper>
      <Header>{title}</Header>
      {tags && <PostTags tags={tags} />}
      {subheader}
    </Wrapper>
  )
}
